import { isAndroid, isIOS } from 'react-device-detect'

import { nMap } from '@web/libs/scheme'

import { useGlobalStaticStateContext } from './useGlobalStaticState'

const UNIVERSAL_LINK = 'https://naverapp.m.naver.com/?urlScheme='
const nAppScheme = {
  IOS_INAPP: {
    PREFIX: 'naversearchapp://inappbrowser?version=10&url=',
  },
  ANDROID_INAPP: {
    PREFIX: 'intent://inappbrowser?version=10&url=',
    PARAMETER:
      '#Intent;scheme=naversearchapp;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.nhn.android.search;end',
  },
}

/**
 * https://pages.oss.navercorp.com/naverapp/naverapp-docs/DeepLink/url_scheme/
 * https://developers.naver.com/docs/utils/mobileapp/
 */
const useNAppScheme = () => {
  const { isMobile, isFromMapsApp, isFromNaverApp } = useGlobalStaticStateContext()
  const getUniversalLink = (url: string) => `${UNIVERSAL_LINK}${encodeURIComponent(url)}`
  const getAndroidScheme = (url: string) =>
    `${nAppScheme.ANDROID_INAPP.PREFIX}${encodeURIComponent(url)}${nAppScheme.ANDROID_INAPP.PARAMETER}`
  const getIosScheme = (url: string) => `${nAppScheme.IOS_INAPP.PREFIX}${encodeURIComponent(url)}`

  const getNAppURLScheme = (url: string) => {
    if (!isMobile || isFromNaverApp) return url

    if (isAndroid) {
      return getAndroidScheme(url)
    }

    if (isIOS) {
      const scheme = getIosScheme(url)
      const universalLink = getUniversalLink(scheme)

      if (isFromMapsApp) {
        return `${nMap.SchemePrefix.EXTERNAL_LINK}${encodeURIComponent(universalLink)}`
      }

      return universalLink
    }

    return url
  }

  return { getNAppURLScheme }
}

export default useNAppScheme
